<template>
  <div
    class="pdf-body"
    :style="{ 'padding-bottom': showagr ? '120px' : '60px' }"
  >
    <pdf
      ref="pdf"
      v-for="i in numPages"
      :key="i"
      :src="pdfSrc"
      :page="i"
      style="padding: 10px 10px 0"
    ></pdf>
    <div class="pdf-footer">
      <div v-if="showagr" class="pdf-tip">
        内容をこ理解いただけましたら、<br />
        「同意する」にチェックを入れてください。
      </div>

      <div
        class="bnt-by"
        :style="{ 'justify-content': showagr ? 'space-between' : 'center' }"
      >
        <label class="checkbox" v-if="showagr"
          ><input type="checkbox" v-model="consent" /><i
            class="icon-checkbox"
          ></i
          >同意</label
        >
        <button @click="goback">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf';
import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js';
export default {
  components: {
    pdf
  },
  data() {
    return {
      pdfUrl: '',
      numPages: null,
      showagr: null,
      source: '',
      seq_no: '',
      consent: false,
      pdfObj: {}
    };
  },
  computed: {
    pdfSrc() {
      //处理pdfUrl返回
      let src = pdf.createLoadingTask({
        url: this.pdfUrl,
        //引入pdf.js字体，templ
        cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.8.335/cmaps/',
        cMapPacked: true,
        CMapReaderFactory
      });
      return src;
    }
  },
  methods: {
    goback() {
      if (this.showagr && this.consent) {
        this.$emit('close', this.consent, this.pdfObj);
      } else {
        this.$emit('close', this.consent, this.pdfObj);
      }
    },
    getNumPages() {
      let obj = {
        url: this.pdfUrl,
        //引入pdf.js字体，templ
        cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.8.335/cmaps/',
        cMapPacked: true,
        CMapReaderFactory
      };
      let loadingTask = pdf.createLoadingTask(obj);
      loadingTask.promise
        .then((pdf) => {
          this.numPages = pdf.numPages;
          this.$emit('read', this.pdfObj); // emit read event when loading successed
        })
        .catch((err) => {
          this.$cErrorDialog({
            title: '',
            left: 'cancel',
            right: 'OK',
            content: '読み込みに失敗しました',
            cancelBtn: false //这个是启用取消按钮，
          });
        });
    },
    pdf_ini(obj, pdfObj) {
      this.consent = false;
      //是否需要同意按钮
      this.showagr = obj.agree != 0 ? true : false;
      this.pdfUrl = obj.path;
      // 传过来的pdf 信息
      this.pdfObj = pdfObj;
      this.getNumPages();
      this.$forceUpdate();
    }
  }
};
</script>

<style lang="less" scoped>
.pdf-body {
  overflow: auto;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  padding-bottom: 60px;
  position: relative;
}
.pdf-footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  min-height: 50px;
  background: white;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.5);
}
.pdf-tip {
  padding: 5px 5%;
  line-height: 25px;
}
.bnt-by {
  display: flex;
  align-items: center;
  padding: 0 5%;
  height: 50px;
  .checkbox {
    display: inline-flex;
    width: 50%;
    align-items: center;
    .icon-checkbox {
      margin-right: 5px;
    }
  }
  button {
    background: #0a89c7;
    border: none;
    border-radius: 10px;
    color: #fff;
    font-size: 18px;
    width: 50%;
    padding: 8px 25px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Pdf/read-pdf.vue